import React, { useState, useRef, useEffect } from "react";
import "./Video.scss";
import VolumeControls from "./VolumeControls.js";

function Video(props) {
    var [volume, setVolume] = useState(100);
    var [muted, setMuted] = useState(true);
    var videoRef = useRef();

    useEffect(() => {
        var volumeVal = volume / 100;

        if (!isNaN(volumeVal)) {
            videoRef.current.volume = volumeVal;
        }

        videoRef.current.muted = muted;
    });

    return (
        <React.Fragment>
            <video
                ref={videoRef}
                src={props.vidsrc}
                alt=""
                className="image-1"
                playsInline="true"
                muted="true"
                loop
                autoPlay
            />
            <VolumeControls
                volume={volume}
                setVolume={setVolume}
                muted={muted}
                setMuted={setMuted}
            />
        </React.Fragment>
    );
}

export default Video;
